<div class="eva-3-modal -sm" CloseModalClick [modal]="this" [ngClass]="{'-show-modal' : isOpen}">
    <div class="modal-header -eva-3-pb-md">
        <i class="modal-close eva-3-icon-close" (click)="close()"></i>
        <div class="modal-title-container">
            <p class="modal-title eva-3-h4">{{ "price-detail-modal.title" | translate }}</p>
        </div>
    </div>
    <div class="modal-content">
        <div class="eva-3-dropdown eva-3-filters-vertical -show-filters -eva-3-bc-white">
                <div>
                    <div class="-eva-3-pb-sm">
                        <div class="eva-3-p -eva-3-pt-xsm -eva-3-pb-xsm">
                            <span class="title">{{serviceTypeMessage}}</span>
                            <span class="-eva-3-fr">
                                <span> {{currencySymbol}} {{priceDetailModal?.basePrice | priceFormatter}} </span>
                            </span>
                        </div>

                        <div class="eva-3-p -eva-3-pt-xsm -eva-3-pb-xsm">
                            <span class="title"> {{ "price-detail-modal.taxes" | translate }} </span>
                            <span class="-eva-3-fr">
                                <span> {{currencySymbol}} {{priceDetailModal?.taxAmount | priceFormatter}} </span>
                            </span>
                        </div>

                        <div *ngIf="discountByDealEnabled" class="eva-3-p -eva-3-pt-xsm -eva-3-pb-xsm -eva-3-tc-green-3">
                            <span class="title">
                               {{"price-detail-modal.discountByDeal" | translate }} {{discountByDealPaymentMethods}}
                            </span>                        
                            <span class="-eva-3-fr" >
                                - {{currencySymbol}} {{priceDetailModal?.discountByDeal | priceFormatter}}
                            </span>
                        </div>

                        <div *ngIf="isRedemptionEnabled() && priceDetailModal?.redemptionDiscount"  class="eva-3-p -eva-3-pt-xsm -eva-3-pb-xsm -eva-3-tc-bubblegum-1">
                            <span class="title">
                               {{redemptionDescription}}
                            </span>
                            <span class="-eva-3-fr" >
                                -   {{currencySymbol}} {{priceDetailModal?.redemptionDiscount}}
                            </span>
                        </div>
                    </div>

                    <div *ngIf="discountByDealEnabled" class="-eva-3-pt-sm -eva-3-pb-sm border-top">
                        <div class="eva-3-p -eva-3-pt-xsm -eva-3-pb-xsm  -eva-3-bold -eva-3-tc-gray-0">
                            <span class="title">
                                   {{ "price-detail-modal.totalPriceWithDeal" | translate }} {{discountByDealPaymentMethods}}
                            </span>
                            <span class="-eva-3-fr -eva-3-bold">
                                <!-- This check is necessary because the loyalty amounts are formatted-->
                                {{currencySymbol}} {{isRedemptionEnabled() ?  priceDetailModal?.totalPriceWithDeal : (priceDetailModal?.totalPriceWithDeal | priceFormatter)}}
                            </span>
                        </div>
                    </div>
                    <div class="-eva-3-pt-sm border-top">
                        <div class="eva-3-p -eva-3-pt-xsm -eva-3-pb-xsm  eva-3-p -eva-3-bold -eva-3-tc-gray-0">
                            <span *ngIf="discountByDealEnabled" class="title">
                                {{ "price-detail-modal.totalPriceWithoutDeal" | translate }} {{discountByDealPaymentMethods}}
                            </span>
                            <span *ngIf="!discountByDealEnabled" class="title">
                                {{ "price-detail-modal.totalPrice" | translate }}
                            </span>
                            <span class="-eva-3-fr -eva-3-bold">
                                <!-- This check is necessary because the loyalty amounts are formatted-->
                                {{currencySymbol}} {{isRedemptionEnabled() ? priceDetailModal?.totalPrice : (priceDetailModal?.totalPrice | priceFormatter)}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</div>
